// utils/getMessageReadByUser.ts

import dayjs from "dayjs";
import { UserResponse } from "stream-chat";
import { DefaultStreamChatGenerics } from "stream-chat-react";

export type ReadData = Record<
  string,
  {
    last_read: string;
    user: UserResponse<DefaultStreamChatGenerics>;
  }
>;

export const getMessageReadByUser = ({
  read,
  messageCreatedAt,
}: {
  read?: ReadData;
  messageCreatedAt?: string | Date;
}) => {
  if (!read || !messageCreatedAt) return [];

  return Object.entries(read)
    .filter(
      ([, { last_read }]) =>
        dayjs(new Date(last_read)).valueOf() >
        dayjs(new Date(messageCreatedAt)).valueOf()
    )
    .map(([, { user, last_read }]) => ({
      user,
      last_read,
    }));
};
